import { useSelector } from 'react-redux';

import { MESSAGES } from '../../../../constants';
import { selectIsLiveChat, selectLastItem } from '../../../common/selectors/chat';
import { selectFieldState } from '../../../common/selectors/field';

// Skipping input focus for some node types as we want to focus user attention on using buttons or other controls rather than typing text.
// Most of the times the input is hidden in builder settings for these cases, but if not, we want to improve the UX by this logict.
const NODE_TYPES_TO_SKIP_FOCUS = [MESSAGES.BUTTONS_VERTICAL];

/**
 * Decides if input should be focused in current state
 */
export function useShouldFocusOnInput(): boolean {
  const { disabled, hidden } = useSelector(selectFieldState);
  const isLiveChat = useSelector(selectIsLiveChat);
  const lastItem = useSelector(selectLastItem);

  if (isLiveChat) {
    return true;
  }

  const isDisallowedByNodeType = lastItem ? NODE_TYPES_TO_SKIP_FOCUS.includes(lastItem.type) : false;

  return !isDisallowedByNodeType && !disabled && !hidden;
}
